import { createAction, props } from '@ngrx/store';
import { ExtendedBaseInterface } from '../auth/auth.models';

export enum ActionTypes {
  SET_SHARED_DATA = '[Shared] Set Shared Data',
  CLEAR_SHARED_DATA = '[Shared] Clear Shared Data',
}

export const setSharedData = createAction(ActionTypes.SET_SHARED_DATA, props<{ data: ExtendedBaseInterface }>());

export const clearSharedData = createAction(ActionTypes.CLEAR_SHARED_DATA);
